@if (distributionChannel) {
  <div class="container single-view" id="edit-distribution-channel">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" appBack [fallbackUrl]="'/distribution-channels/' + distributionChannelId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'DISTRIBUTION_CHANNELS.BTN_BACK_TO_DISTRIBUTION_CHANNEL' | translate }}</a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr">
          <div class="title-wr">
            <h1 data-testid="edit-distributionchannel-title" class="section-title">{{ 'DISTRIBUTION_CHANNEL_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <!-- main content -->
              <form class="mt-0" [formGroup]="distributionChannelForm" data-testid="edit-distributionchannel-form">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 class="border-b pb-3">{{ 'DISTRIBUTION_CHANNEL_UPDATE.DISTRIBUTION_CHANNEL_DETAILS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-distributionchannel-field-name" class="block text-sm" for="name">{{ 'DISTRIBUTION_CHANNEL_UPDATE.NAME' | translate }} <i
                    class="icon-required-field"></i></label>
                    <input data-testid="edit-distributionchannel-name-input" type="text" formControlName="name" autocomplete="off">
                    @if (distributionChannelForm.get('name')?.invalid && distributionChannelForm.get('name')?.touched) {
                      <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-distributionchannel-field-code" class="block text-sm" for="code">{{ 'DISTRIBUTION_CHANNEL_UPDATE.CODE' | translate }} <i class="icon-required-field"></i></label>
                    <input data-testid="edit-distributionchannel-code-input" type="text" formControlName="code" autocomplete="off">
                    @if (distributionChannelForm.get('code')?.invalid && distributionChannelForm.get('code')?.touched) {
                      <small data-testid="code-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-6 mb-4 pt-8 border-t">
                    <div class="flex items-center justify-end gap-3">
                      <button data-testid="edit-distributionchannel-update-distributionchannel-button"  class="btn primary-btn" [disabled]="distributionChannelForm.invalid" (click)="submitForm()">{{
                      'DISTRIBUTION_CHANNEL_UPDATE.BTN_UPDATE_DISTRIBUTION_CHANNEL' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
              <!-- /main content -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
